import {
  Briefcase,
  BarChart2,
  Settings,
  LucideIcon,
  Bookmark,
  Calendar as CalendarIcon,
  MessageSquare,
  PackagePlus,
  PiggyBank,
} from "lucide-react";

type Submenu = {
  href: string;
  label: string;
  active?: boolean;
};

type Menu = {
  href: string;
  label: string;
  active?: boolean;
  icon: LucideIcon;
  submenus?: Submenu[];
};

type Group = {
  groupLabel: string;
  menus: Menu[];
};

export function getMenuList(
  pathname: string,
  options: { isAdmin?: boolean } = {},
): Group[] {
  const isAdmin = options.isAdmin ?? false;

  const groups: Group[] = [
    {
      groupLabel: "",
      menus: [
        {
          href: "/portfolio",
          label: "Portfolio",
          icon: Briefcase,
          active: pathname === "/portfolio",
        },
        {
          href: "/budget",
          label: "Budget",
          icon: PiggyBank,
          active: pathname.startsWith("/budget"),
        },
      ],
    },
    {
      groupLabel: "Market",
      menus: [
        {
          href: "/watchlists",
          label: "Watchlists",
          icon: Bookmark,
          active: pathname.startsWith("/watchlists"),
        },
        {
          href: "/screener",
          label: "Screener",
          icon: BarChart2,
          active: pathname.startsWith("/screener"),
        },
        {
          href: "/calendar",
          label: "Calendar",
          icon: CalendarIcon,
          active: pathname.startsWith("/calendar"),
        },
      ],
    },
    {
      groupLabel: "Settings",
      menus: [
        {
          href: "/account",
          label: "Account",
          icon: Settings,
          active: pathname === "/account",
        },
        {
          href: "#feedback",
          label: "Send Feedback",
          icon: MessageSquare,
          active: false,
        },
      ],
    },
  ];

  if (isAdmin) {
    groups.push({
      groupLabel: "Admin",
      menus: [
        {
          href: "/admin/assets",
          label: "Assets",
          icon: PackagePlus,
          active: pathname.startsWith("/admin/assets"),
        },
        {
          href: "/admin/feedbacks",
          label: "User Feedbacks",
          icon: MessageSquare,
          active: pathname.startsWith("/admin/feedbacks"),
        },
      ],
    });
  }

  return groups;
}
